import api from '.';

export const OPORTUNIDADES_ENDPOINT = '/oportunidades';
export const COUNT_OPORTUNIDADES_ENDPOINT = `${OPORTUNIDADES_ENDPOINT}/count`;
export const DETALLE_OPORTUNIDAD_ENDPOINT = `${OPORTUNIDADES_ENDPOINT}}/{idOportunidad}/detalle`;
export const COLA_TRABAJO_ENDPOINT = `${OPORTUNIDADES_ENDPOINT}/cola-trabajo`;
export const REGISTRO_ACCION_ENDPOINT = `${OPORTUNIDADES_ENDPOINT}/{idOportunidad}/accion`;

export const getAllOportunidades = async (params) => {
    const response = await api.get(OPORTUNIDADES_ENDPOINT, { params });
    return response;
};

export const getOportunidadById = async (idOportunidad) => {
    const response = await api.get(
        `${OPORTUNIDADES_ENDPOINT}/${idOportunidad}`
    );
    return response;
};

export const getDetalleOportunidad = async (idOportunidad) => {
    const response = await api.get(
        `${OPORTUNIDADES_ENDPOINT}/${idOportunidad}/detalle`
    );
    return response;
};

export const countOportunidades = async () => {
    const response = await api.get(COUNT_OPORTUNIDADES_ENDPOINT);
    return response;
};

export const getColaTrabajo = async () => {
    const response = await api.get(COLA_TRABAJO_ENDPOINT);
    return response;
};

export const createRegistroAccion = async (idOportunidad, idSubAccion) => {
    const response = await api.post(
        `${OPORTUNIDADES_ENDPOINT}/${idOportunidad}/accion`,
        {
            idOportunidad,
            idSubAccion,
        }
    );
    return response;
};
